import { connect } from 'react-redux'
import { getPrescriberSales } from 'store/prescribers'
import PrescribersView from './PrescribersView.jsx'

const mapDispatchToProps = {
  getPrescriberSales
}

const mapStateToProps = (state) => {
  return {
    remsPrescribers: state.prescribers.remsPrescribers,
    isFetchingPrescriberSales: state.ui.isFetchingPrescriberSales
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PrescribersView)



// WEBPACK FOOTER //
// ./src/routes/Clinic/components/PrescribersContainer.jsx